export enum FileType {
  MsWord = "application/msword",
  OctetStream = "application/octet-stream",
  Pdf = "application/pdf",
  ExcelMacroenabled12 = "application/vnd.ms-excel.template.macroenabled.12",
  WordProcessingDoc = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  ImageJpeg = "image/jpeg",
  ImagePng = "image/png",
  TextPlain = "text/plain",
}
